import{defineMessages}from'react-intl';

export default defineMessages({
label:{
id:'select_contact.label',
defaultMessage:'Selling Support Contact'},

addNewContact:{
id:'select_contact.addNewContact',
defaultMessage:'ADD NEW CONTACT'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9DcmVhdGVTZWxsaW5nU3VwcG9ydFBhZ2UvU2VsZWN0Q29udGFjdC9TZWxlY3RDb250YWN0Lm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwibGFiZWwiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwiYWRkTmV3Q29udGFjdCJdLCJtYXBwaW5ncyI6IkFBQUEsT0FBU0EsY0FBVCxLQUErQixZQUEvQjs7QUFFQSxjQUFlQSxnQkFBZTtBQUM1QkMsTUFBTztBQUNMQyxHQUFJLHNCQURDO0FBRUxDLGVBQWdCLHlCQUZYLENBRHFCOztBQUs1QkMsY0FBZTtBQUNiRixHQUFJLDhCQURTO0FBRWJDLGVBQWdCLGlCQUZILENBTGEsQ0FBZixDQUFmIiwiZmlsZSI6IlNlbGVjdENvbnRhY3QubWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGRlZmluZU1lc3NhZ2VzIH0gZnJvbSAncmVhY3QtaW50bCc7XG5cbmV4cG9ydCBkZWZhdWx0IGRlZmluZU1lc3NhZ2VzKHtcbiAgbGFiZWw6IHtcbiAgICBpZDogJ3NlbGVjdF9jb250YWN0LmxhYmVsJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1NlbGxpbmcgU3VwcG9ydCBDb250YWN0JyxcbiAgfSxcbiAgYWRkTmV3Q29udGFjdDoge1xuICAgIGlkOiAnc2VsZWN0X2NvbnRhY3QuYWRkTmV3Q29udGFjdCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdBREQgTkVXIENPTlRBQ1QnLFxuICB9LFxufSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/pages/CreateSellingSupportPage/SelectContact/SelectContact.messages.js
// module id = 2393
// module chunks = 0